import React from "react";

import SwitchLang from "./SwitchLang";
import Icon from "./Icon";

import { Logo, SearchIcon } from "../../Icons/Icon";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SearchModal from "../../Modals/SearchModal";
import ImageAyat from '../../assets/Images/ayat.png'
function Head({ isOpenSearch, setIsOpenSearch }) {
  const { t, i18n } = useTranslation();

  const handleOpenSearch = () => {
    setIsOpenSearch(true);
  };
  return (
    <div className="flex gap-1 items-center justify-between px-4 bg-white py-2">
      <div className="flex  flex-col items-center ">
        <div className="flex  items-center  justify-center">
          <Logo width={"w-20  md:w-28 xl:w-20"} height={"h-20 md:h-28 xl:h-20"} />


        </div>
        <div>
          <p className="hidden md:block  text-gray-600  text-xs text-center" >{t("humanity")}</p>
        </div>
      </div>

      <Link to={"/"}>
        <div className="flex gap-3  items-center">

          <div className="flex flex-col text-5xl">
            <div className={` ${(i18n.language === "ar" || i18n.language === "ckb") && "flex flex-row-reverse"} items-center justify-center text-xl hidden md:flex md:gap-1`}>
              <p className="font-bold hidden md:block text-lg xl:text-3xl text-[#07A024]">{t("zad")}</p>
              <p className="hidden md:block  text-lg  xl:text-3xl ">{t("organization")}</p>
            </div>

            <div className="w-32 md:w-72  ">
              <img src={ImageAyat} className="w-full hidden md:block     rounded-sm  object-contain " alt="" />
            </div>


          </div>

        </div>
      </Link>
      <div className="flex z-50 gap-4 items-center">

        <Icon />

        <div className={localStorage.getItem("lang") === "ar" || localStorage.getItem("lang") === "ckb" ? "flex  items-center flex-row-reverse" : "flex  items-center"}>
          <SearchIcon openModal={handleOpenSearch} />
          <SwitchLang />

        </div>
      </div>

      {
        isOpenSearch && (
          <SearchModal isOpen={isOpenSearch} onClose={() => {
            setIsOpenSearch(false);
            document.body.style.overflow = 'unset';
          }} />
        )
      }
    </div>
  );
}

export default Head;
